import React, { Component } from 'react'
import { MDBIcon } from "mdbreact";

import SearchAction from '../../../../actions/SearchPassword'
import { connect } from 'react-redux'

class Search extends Component {
    state= {
    }
    onSearch = (e) => {
        if (this.props.data) {
            let { data, search } = this.props
            let filtered = data.filter(val => {
                let status = val[1].website.toLowerCase().includes(e.target.value.toLowerCase())
                if (status) {
                    return val
                }
            })
            search(filtered)
        }
    }

    render() {
        return (
            <div className="d-flex align-items-center">
                <MDBIcon icon="search" />
                <input onChange={this.onSearch} className="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search" />
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        search: (content) => dispatch(SearchAction(content))
    }
}

export default connect(null, mapDispatchToProps) (Search)
